import styled from 'styled-components';
import {
  Button,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'react-bootstrap';

export const StyledModal = styled(Modal).withConfig({
  shouldForwardProp: (prop) => !['showModalServiceDeskOpen'].includes(prop),
})`
  &.modal {
    filter: ${({ showModalServiceDeskOpen }) =>
      showModalServiceDeskOpen ? 'brightness(40%)' : 'none'};
    backdrop-filter: ${({ showModalServiceDeskOpen }) =>
      showModalServiceDeskOpen ? 'brightness(40%)' : 'none'};
  }
  
  .modal-content {
    background: transparent;
    border: none;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }
  
  .modal-dialog {
    max-width: 1200px;
    width: 95vw;
    margin: 1.75rem auto;
  }
  
  @media (max-width: 1200px) {
    .modal-dialog {
      max-width: 95vw;
      margin: 1rem auto;
    }
  }
`;

export const StyledServiceDeskModal = styled(Modal)`
  .modal-content {
    background: transparent;
    border: none;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }
`;

export const StyledModalBody = styled(ModalBody)`
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 20px;
  position: relative;
  max-height: 80vh;
  overflow-y: auto;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 80%, rgba(244, 241, 222, 0.05) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(244, 241, 222, 0.03) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }
  
  * label {
    margin-bottom: 6px;
    color: #f4f1de;
    font-weight: 500;
    position: relative;
    z-index: 1;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    font-size: 14px;
  }
  
  .form-control, .form-select {
    background: rgba(244, 241, 222, 0.1) !important;
    border: 1px solid rgba(244, 241, 222, 0.2) !important;
    color: #f4f1de !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    position: relative;
    z-index: 1;
    padding: 12px 16px !important;
    font-size: 14px !important;
    backdrop-filter: blur(10px) !important;
    
    &:focus {
      background: rgba(244, 241, 222, 0.15) !important;
      border-color: rgba(244, 241, 222, 0.4) !important;
      box-shadow: 0 0 0 0.2rem rgba(244, 241, 222, 0.25) !important;
      color: #f4f1de !important;
      transform: translateY(-1px) !important;
    }
    
    &::placeholder {
      color: rgba(244, 241, 222, 0.6) !important;
    }
    
    &:hover {
      border-color: rgba(244, 241, 222, 0.3) !important;
      background: rgba(244, 241, 222, 0.12) !important;
    }
  }
  
  .form-control:focus, .form-select:focus {
    background: rgba(244, 241, 222, 0.15) !important;
    border-color: rgba(244, 241, 222, 0.4) !important;
    box-shadow: 0 0 0 0.2rem rgba(244, 241, 222, 0.25) !important;
    color: #f4f1de !important;
  }
  
  .form-select {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23f4f1de' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e") !important;
    background-repeat: no-repeat !important;
    background-position: right 12px center !important;
    background-size: 16px 12px !important;
    padding-right: 40px !important;
    
    option {
      background: rgba(26, 26, 46, 0.95) !important;
      color: #f4f1de !important;
      border: none !important;
    }
    
    &:hover {
      background: rgba(244, 241, 222, 0.12) !important;
      border-color: rgba(244, 241, 222, 0.3) !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23f4f1de' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e") !important;
      background-repeat: no-repeat !important;
      background-position: right 12px center !important;
      background-size: 16px 12px !important;
    }
    
    &:focus {
      background: rgba(244, 241, 222, 0.15) !important;
      border-color: rgba(244, 241, 222, 0.4) !important;
      box-shadow: 0 0 0 0.2rem rgba(244, 241, 222, 0.25) !important;
      color: #f4f1de !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23f4f1de' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e") !important;
      background-repeat: no-repeat !important;
      background-position: right 12px center !important;
      background-size: 16px 12px !important;
    }
  }
  
  /* Custom scrollbar para o body do modal */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(244, 241, 222, 0.1);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(244, 241, 222, 0.3);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(244, 241, 222, 0.5);
  }
`;

export const StyledModalHeader = styled(ModalHeader)`
  background: linear-gradient(90deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  border-bottom: 1px solid rgba(244, 241, 222, 0.2);
  color: #f4f1de;
  padding: 12px 20px;
  border-radius: 12px 12px 0 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 50%, rgba(244, 241, 222, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 50%, rgba(244, 241, 222, 0.05) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
    border-radius: 12px 12px 0 0;
  }
  
  .modal-title {
    color: #f4f1de;
    font-weight: 600;
    font-size: 18px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 1;
  }
  
  .btn-close {
    filter: invert(1) brightness(0.8);
    opacity: 0.8;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;
    
    &:hover {
      opacity: 1;
      transform: scale(1.1);
    }
  }
`;

export const StyledDescription = styled.div`
  background: rgba(244, 241, 222, 0.1);
  border: 1px solid rgba(244, 241, 222, 0.2);
  color: #f4f1de;
  font-size: 14px;
  padding: 12px 16px;
  margin-bottom: 12px;
  line-height: 20px;
  max-height: 150px;
  border-radius: 8px;
  overflow: auto;
  white-space: pre-line;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 1;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(244, 241, 222, 0.1);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(244, 241, 222, 0.3);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(244, 241, 222, 0.5);
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  color: #f4f1de;
  font-weight: 500;
  padding: 6px 10px;
  background: rgba(244, 241, 222, 0.1);
  border: 1px solid rgba(244, 241, 222, 0.2);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 1;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

export const StyledRiskFactor = styled.section`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  background: rgba(244, 241, 222, 0.03);
  border: 1px solid rgba(244, 241, 222, 0.1);
  border-radius: 12px;
  padding: 20px;
  margin: 15px 0;
  gap: 20px;

  div {
    flex-grow: 1;
    min-width: 0;
  }

  aside {
    margin-left: 0;
    display: flex;
    width: 35%;
    min-width: 200px;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;

    label {
      font-size: 16px;
      min-height: 20px;
      margin-top: 10px;
      color: #f4f1de;
      font-weight: 500;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }

    span {
      background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
      border: 1px solid rgba(244, 241, 222, 0.2);
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      color: #f4f1de !important;
      min-height: 80px;
      font-size: 36px;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: 
          radial-gradient(circle at 20% 50%, rgba(244, 241, 222, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 80% 50%, rgba(244, 241, 222, 0.05) 0%, transparent 50%);
        pointer-events: none;
        z-index: 0;
        border-radius: 8px;
      }
    }
  }

  select {
    margin-bottom: 10px;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    
    aside {
      width: 100%;
      min-width: auto;
    }
  }
`;

export const StyledFormLabel = styled(Form.Label)`
  font-weight: bold;
  color: #f4f1de;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
`;

export const StyledResponseContainer = styled(Row)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgba(244, 241, 222, 0.05);
  border: 1px solid rgba(244, 241, 222, 0.1);
  border-radius: 12px;
  padding: 15px;
  margin: 15px 0;
  position: relative;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 50%, rgba(244, 241, 222, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 50%, rgba(244, 241, 222, 0.02) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
    border-radius: 12px;
  }
`;

export const StyledStrong = styled.strong`
  color: ${(props) => props.color};
  font-weight: bold;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
`;

export const StyledModalFooter = styled(ModalFooter)`
  background: linear-gradient(90deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  border-top: 1px solid rgba(244, 241, 222, 0.2);
  padding: 12px 20px;
  border-radius: 0 0 12px 12px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 50%, rgba(244, 241, 222, 0.05) 0%, transparent 50%),
      radial-gradient(circle at 80% 50%, rgba(244, 241, 222, 0.03) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
    border-radius: 0 0 12px 12px;
  }
  
  .btn {
    position: relative;
    z-index: 1;
    background: rgba(244, 241, 222, 0.1);
    border: 1px solid rgba(244, 241, 222, 0.2);
    color: #f4f1de;
    border-radius: 8px;
    padding: 8px 16px;
    font-weight: 500;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    
    &:hover {
      background: rgba(244, 241, 222, 0.2);
      border-color: rgba(244, 241, 222, 0.4);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
    
    &:active {
      transform: translateY(0);
    }
    
    &.btn-primary {
      background: rgba(13, 110, 253, 0.2);
      border-color: rgba(13, 110, 253, 0.4);
      
      &:hover {
        background: rgba(13, 110, 253, 0.3);
        border-color: rgba(13, 110, 253, 0.6);
      }
    }
    
    &.btn-secondary {
      background: rgba(108, 117, 125, 0.2);
      border-color: rgba(108, 117, 125, 0.4);
      
      &:hover {
        background: rgba(108, 117, 125, 0.3);
        border-color: rgba(108, 117, 125, 0.6);
      }
    }
    
    &.btn-light {
      background: rgba(248, 249, 250, 0.1);
      border-color: rgba(248, 249, 250, 0.2);
      color: #f4f1de;
      
      &:hover {
        background: rgba(248, 249, 250, 0.2);
        border-color: rgba(248, 249, 250, 0.4);
      }
    }
  }
`;
